import { lang } from '@src/lang'
import {
    Box,
    Button,
    Center,
    FileUpload,
    Group,
    Icon,
    Input,
    Spinner,
    Text,
    VStack,
} from '@chakra-ui/react'
import { LuUpload } from 'react-icons/lu'
import { MainPageStoreContext } from '@src/pages/MainPageStore'
import { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { isValidUrl } from '@src/helpers/utils'

interface Props {
    handleFileInput?: (files: File[]) => void
    handleLink?: (link: string) => void
}

const acceptedFormat = [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'application/zip',
    'application/x-zip-compressed',
]

export const DragDrop = observer((props: Props) => {
    const store = useContext(MainPageStoreContext)
    const [link, setLink] = useState<string | undefined>()

    const handleFileInput = (e: { files: File[] }) => {
        if (e.files) {
            props.handleFileInput?.(Array.from(e.files))
        }
    }

    const onInputClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation()
        e.preventDefault()
    }

    const onButtonClick = async () => {
        if (!link || !isValidUrl(link)) {
            return
        }

        if (props.handleLink) {
            props.handleLink(link)
        }
    }

    return (
        <FileUpload.Root
            alignItems="stretch"
            accept={acceptedFormat}
            onFileAccept={handleFileInput}
            maxFiles={50}
        >
            <FileUpload.HiddenInput />
            <FileUpload.Dropzone minHeight={30} position={'relative'}>
                <Icon size="lg" color="fg.muted">
                    <LuUpload />
                </Icon>
                <FileUpload.DropzoneContent>
                    <Box>{lang.dragDropPlaceholder}</Box>
                    <Box color="fg.muted">{lang.dragDropFileFormat}</Box>
                    <Box>или используйте ссылку на Yandex Disk</Box>
                    <Group attached w="full" onClick={e => onInputClick(e)}>
                        <Input
                            flex="1"
                            placeholder={'Вставьте ссылку...'}
                            onChange={e => setLink(e.currentTarget.value)}
                            value={link}
                        />
                        <Button bg="bg.subtle" variant="outline" onClick={onButtonClick}>
                            Отправить
                        </Button>
                    </Group>
                </FileUpload.DropzoneContent>
                {store.unzipStatus && (
                    <Box pos="absolute" inset="0" bg="bg/90">
                        <Center h="full">
                            <VStack>
                                <Spinner borderWidth={2} />
                                <Text fontWeight={500}>
                                    {lang.unpacking}
                                    {lang.threeDot}
                                </Text>
                            </VStack>
                        </Center>
                    </Box>
                )}
            </FileUpload.Dropzone>
        </FileUpload.Root>
    )
})
